var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "组件宽度(cm)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-style_height",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入宽度",
              precision: _vm.precision,
              step: _vm.step,
              min: 0,
              max: 30
            },
            model: {
              value: _vm.width,
              callback: function($$v) {
                _vm.width = _vm._n($$v)
              },
              expression: "width"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f45db99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f45db99","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/style_setting/SettingStyleWidth.vue
// module id = null
// module chunks = 